import * as yup from "yup"
import REQUIRED_FIELDS from "components/FormEntities/FormSource/required_fields.json"

const _valuesOIM = {
  id: yup.string().required("required-field"),
  name: yup.string().required("required-field"),
  alias: yup.string(),
  type: yup.string().required("required-field"),
  physicalLink: yup.string().when("type", ([type]: any) => {
    if (type === "virtual") {
      return yup.string().required("required-field")
    }
    return yup.string().nullable()
  }),
  location: yup
    .array(
      yup.object().shape({
        key: yup.string().required("required-field"),
        type: yup.string().required("required-field"),
        value: yup.mixed().required("required-field"),
      }),
    )
    .min(1, "you-must-enter-at-least-1-location")
    .required("required-field")
    .typeError("you-must-enter-at-least-one-value")
    .test(
      "required-keys",
      "Faltan campos requeridos: " + REQUIRED_FIELDS.location_field_form.join(", "),
      (value: any) => {
        if (!value) return true
        const keys = value.map((v: any) => v.key)
        const requiredKeys = REQUIRED_FIELDS.location_field_form
        return requiredKeys.every((key: string) => keys.includes(key))
      },
    ),
  safety: yup
    .number()
    .transform((value, originalValue) => (isNaN(value) || originalValue === "" ? null : value))
    .integer()
    .min(0)
    .required("required-field"),
  ranking: yup
    .number()
    .transform((value, originalValue) => (isNaN(value) || originalValue === "" ? null : value))
    .integer()
    .min(0)
    .required("required-field"),
  storePickup: yup.boolean(),
  enabled: yup.boolean(),
  contact: yup.object().shape({
    name: yup.string(),
    phone: yup.string(),
  }),
  custom: yup
    .array(
      yup.object().shape({
        key: yup.string().required("required-field"),
        type: yup.string().required("required-field"),
        value: yup.mixed().required("required-field"),
      }),
    )
    .test(
      "required-keys",
      "Faltan campos requeridos: " + REQUIRED_FIELDS.custom_field_form.join(", "),
      (value: any) => {
        if (!value) return true
        const keys = value.map((v: any) => v.key)
        const requiredKeys = REQUIRED_FIELDS.custom_field_form
        // If there are no required fields, this effectively just returns true
        return requiredKeys.every((key: string) => keys.includes(key))
      },
    ),
}

const schemaValidationCompleteSources = yup.object().shape({
  ..._valuesOIM,
  volumeCapacity: yup.array(
    yup.object().shape({
      daysOfWeek: yup
        .array(yup.string())
        .min(1, "you-must-enter-at-least-1-day")
        .required("required-field")
        .typeError("you-must-enter-at-least-one-value"),
      overCapacity: yup
        .number()
        .transform((value, originalValue) => (isNaN(value) || originalValue === "" ? null : value))
        .integer()
        .min(0)
        .required("required-field"),
      capacity: yup
        .number()
        .transform((value, originalValue) => (isNaN(value) || originalValue === "" ? null : value))
        .integer()
        .min(0)
        .required("required-field"),
    }),
  ),
  dispatchCapacity: yup.array(
    yup.object().shape({
      daysOfWeek: yup
        .array(yup.string())
        .min(1, "you-must-enter-at-least-1-shippingType")
        .required("required-field")
        .typeError("you-must-enter-at-least-one-value"),
      overCapacity: yup
        .number()
        .transform((value, originalValue) => (isNaN(value) || originalValue === "" ? null : value))
        .integer()
        .min(0)
        .required("required-field"),
      capacity: yup
        .number()
        .transform((value, originalValue) => (isNaN(value) || originalValue === "" ? null : value))
        .integer()
        .min(0)
        .required("required-field"),
      productType: yup.string().required("required-field"),
      deliveryType: yup.string().required("required-field"),
    }),
  ),
  schedule: yup.array(
    yup.object().shape({
      shippingType: yup
        .array(yup.string())
        .min(1, "you-must-enter-at-least-1-shippingType")
        .required("required-field")
        .typeError("you-must-enter-at-least-one-value"),
      productType: yup.string().required("required-field"),
      enableTime: yup.object().shape({
        from: yup.mixed(),
        to: yup.mixed(),
      }),
      disabled: yup.boolean(),
      coverageRadius: yup
        .number()
        .transform((value, originalValue) => (isNaN(value) || originalValue === "" ? null : value))
        .min(0)
        .nullable()
        .notRequired(),
      deliveryType: yup.string().required("required-field"),
      leadtime: yup.object().shape({
        value: yup
          .number()
          .integer()
          .transform((value, originalValue) => (isNaN(value) || originalValue === "" ? null : value))
          .min(0)
          .nullable()
          .notRequired(),
        unit: yup.string().nullable(),
      }),
      deliverySlots: yup.array(
        yup.object().shape({
          dayOfWeek: yup
            .number()
            .transform((value, originalValue) => (isNaN(value) || originalValue === "" ? null : value))
            .required("required-field"),
          from: yup.string().required("required-field"),
          to: yup.string().required("required-field"),
          label: yup.string().required("required-field"),
        }),
      ),
    }),
  ),
  crossdock: yup.array(
    yup.object().shape({
      value: yup
        .number()
        .integer()
        .transform((value, originalValue) => (isNaN(value) || originalValue === "" ? null : value))
        .min(0)
        .required("required-field"),
      unit: yup.string().required("required-field"),
      productType: yup.string().required("required-field"),
    }),
  ),
  workingSessions: yup.array(
    yup.object().shape({
      productType: yup.string().required("required-field"),
      capacity: yup
        .number()
        .transform((value, originalValue) => (isNaN(value) || originalValue === "" ? null : value))
        .nullable()
        .notRequired(),
      daysOfWeek: yup
        .array(yup.string())
        .min(1, "you-must-enter-at-least-1-shippingType")
        .required("required-field")
        .typeError("you-must-enter-at-least-one-value"),
      from: yup.string(),
      to: yup.string(),
      enable_locktime: yup.boolean().nullable(),
      lockTime: yup.object().shape({
        from: yup.mixed(),
        to: yup.mixed(),
      }),
    }),
  ),
  workingTime: yup.array(
    yup.object().shape({
      daysOfWeek: yup
        .array(yup.string())
        .min(1, "you-must-enter-at-least-1-day")
        .required("required-field")
        .typeError("you-must-enter-at-least-one-value"),
      from: yup.string().required("required-field"),
      to: yup.string().required("required-field"),
    }),
  ),
  calendarSettings: yup.object().shape({
    timezone: yup.string(),
    nonWorkingDays: yup.array(yup.string()),
    nonWorkingDates: yup.array(yup.string()),
  }),
})

export const schemaValidationServiceSources = yup.object().shape({
  ..._valuesOIM,
})

export default schemaValidationCompleteSources
